import {ChangeEvent, FC} from 'react';
import {extractPhoneDigits, formatPhoneDisplay} from '../../model';
import {StepLayout} from 'features/registration';
import {TextInput} from '../components/TextInput';
import styles from './PaymentDetailsStep.module.css';

type Props = {
	value: string;
	onChange: (phoneDigits: string) => void;
	onMoreAboutSbp?: () => void;
};

export const PaymentSbpPhoneStep: FC<Props> = ({value, onChange, onMoreAboutSbp}) => {
	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		onChange(extractPhoneDigits(event.target.value));
	};

	return (
		<StepLayout variant="fill">
			<StepLayout.Title>Введите номер телефона</StepLayout.Title>

			<StepLayout.Content className={styles.field}>
				<div className={styles.inputRow}>
					<span className={styles.prefix}>+ 7</span>
					<TextInput
						name="paymentPhone"
						className={styles.input}
						value={formatPhoneDisplay(value)}
						placeholder="(000) 000-00-00"
						inputMode="numeric"
						autoComplete="tel"
						autoFocus
						onChange={handleChange}
						onClear={() => onChange('')}
					/>
				</div>
				<StepLayout.TextLink onClick={onMoreAboutSbp}>Подробнее о СБП</StepLayout.TextLink>
			</StepLayout.Content>
		</StepLayout>
	);
};
